import { render, staticRenderFns } from "./attr-item.vue?vue&type=template&id=560f448a&scoped=true"
import script from "./attr-item.vue?vue&type=script&lang=js"
export * from "./attr-item.vue?vue&type=script&lang=js"
import style0 from "./attr-item.vue?vue&type=style&index=0&id=560f448a&prod&lang=scss&scoped=true"
import style1 from "./attr-item.vue?vue&type=style&index=1&id=560f448a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f448a",
  null
  
)

export default component.exports